import { useEffect, useState } from 'react';
import s from './InlineXPFloat.module.css';

/**
 * @param {Object} props
 * @param {number} props.xp — XP amount to display (default 10)
 * @param {string} props.variant — visual variant from MicroVariantEngine
 * @param {number} props.intensity — 0-1 intensity multiplier
 * @param {{ x: number, y: number }} props.origin — screen position to animate from
 * @param {function} props.onComplete — callback when animation finishes
 */
export default function InlineXPFloat({ xp = 10, variant = 'standard', intensity = 0.5, origin, onComplete }) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    requestAnimationFrame(() => setMounted(true));
    const timer = setTimeout(() => {
      if (onComplete) onComplete();
    }, 1200); // Match animation duration
    return () => clearTimeout(timer);
  }, [onComplete]);

  const variantClass = s[variant] || s.standard;
  const scale = 0.8 + intensity * 0.4; // intensity affects size: 0.8 to 1.2

  return (
    <div
      className={`${s.float} ${variantClass} ${mounted ? s.animate : ''}`}
      style={{
        left: origin?.x ?? '50%',
        top: origin?.y ?? '50%',
        '--float-scale': scale,
      }}
      aria-hidden="true"
    >
      <span className={s.text}>+{xp}</span>
      <span className={s.xpLabel}>XP</span>

      {/* Variant-specific decorations */}
      {variant === 'ripple' && <div className={s.rippleRing} />}
      {variant === 'gold_burst' && (
        <>
          <div className={s.sparkle} style={{ '--spark-angle': '0deg' }} />
          <div className={s.sparkle} style={{ '--spark-angle': '72deg' }} />
          <div className={s.sparkle} style={{ '--spark-angle': '144deg' }} />
          <div className={s.sparkle} style={{ '--spark-angle': '216deg' }} />
          <div className={s.sparkle} style={{ '--spark-angle': '288deg' }} />
        </>
      )}
    </div>
  );
}
